/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_Filter_KindInputs */



/**
* | output |
* | --- |
* | "Filter by kind" |
*
* @param {Promo_Ledger_Filter_KindInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_filter_kind = /** @type {((inputs?: Promo_Ledger_Filter_KindInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_Filter_KindInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtrer par type")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtrar por tipo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Filtrar por tipo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtra per tipo")
	return /** @type {LocalizedString} */ ("Filter by kind")
});